export function formatHoursPerWeek(
  hoursPerWeek?: number | null,
): string | null {
  if (!hoursPerWeek) {
    return null
  }

  return `${hoursPerWeek}h/semaine`
}
